export default "__VITE_ASSET__x79CGl1K__"